/**
 * Paged lists configuration.
 *
 * Adds boilerplate configuration to routes with paged lists, which are identified
 * by the `paging` property. If route.paging is `true`, the parameters are added without
 * key. If it's a string, params are added with the string postfixed.
 *
 * @example <caption>Per-route paging</caption>
 * const route = {
 *   paging: true,
 *   resolve: {
 *     items: ($transition$, Item, TmrPaging) => Item.pagedQuery(TmrPaging.resolveParams($transition$))
 *   }
 * }
 *
 * @example <caption>Multiple pagers in the same route</caption>
 * const route = {
 *   paging: ['items', 'products'],
 *   resolve: {
 *     items: ($transition$, Item, TmrPaging) => Item.pagedQuery(TmrPaging.resolveParams($transition$, {}, 'items')),
 *     products: ($transition$, Product, TmrPaging) => Item.pagedQuery(TmrPaging.resolveParams($transition$, {}, 'products'))
 *   }
 * }
 *
 * @type {ngConfig}
 * @see TmrPaging
 */
function tmrPagingRoutesConfig(TmrRoutesProvider, TmrPagingProvider) {
  'ngInject'
  let callback = routes =>
    routes
      .filter(route => route.paging)
      .forEach(route => TmrPagingProvider.processRoute(route))
  TmrRoutesProvider.afterConfigCallbacks.push(callback)
}

export { tmrPagingRoutesConfig as config }
